import React, { createContext, useEffect, useState } from 'react';
import Header from "../component/common/header";
import Main from "../component/common/main";
import CasinoVideo from "../component/layout/CasinoVideo";
import LoginModal from "../component/pop_pages/user/login_popup";
import { RegisterModal } from "../component/pop_pages/user/register_popup";
import CookieSetComponent from "../component/common/CookieSetComponent";
import GameLoading from "../component/provider/game_loading_provider";
import useUser, { PrivateUser, PrivateUserDefault } from "../hooks/useUser";
import api from "../util/api";

import 'bootstrap/dist/css/bootstrap.min.css';
import "../_asset/css/css.css"
import LobbyModalProvider from "../component/provider/lobby_modal_provider";
import EventAdLayout from '../component/banner/event_ad';


interface ACTION_INTERFACE {
    SetLoginPop: () => void
    SetRegisterPop: () => void
    User: PrivateUser
    MutateUser: () => void
}

export const actionContext = createContext<ACTION_INTERFACE>({
    SetLoginPop: () => { },
    SetRegisterPop: () => { },
    User: PrivateUserDefault,
    MutateUser: () => { }
})

export default function Home() {
    const { user, mutateUser } = useUser()

    const [loginShow, setLoginShow] = useState(false)
    const [registerShow, setRegisterShow] = useState<boolean>(false)
    const [User, setUser] = useState<PrivateUser>(user as PrivateUser)

    function SetLoginPop() {
        setLoginShow(true)
    }
    function SetRegisterPop() {
        setRegisterShow(true)
    }
    function MutateUser() {
        mutateUser()
    }
    useEffect(() => {
        setUser(user as PrivateUser)
    }, [user])

    return (
        <actionContext.Provider value={{ SetLoginPop, SetRegisterPop, User, MutateUser }}>
            <LobbyModalProvider>
                <GameLoading>
                    <CookieSetComponent />
                    <CasinoVideo />
                    <div id={`body`}>
                        <Header />
                        <main id='main-container'>
                            <EventAdLayout>
                                <Main />
                            </EventAdLayout>
                        </main>
                    </div>
                </GameLoading>
            </LobbyModalProvider>
            <LoginModal loginPopShow={loginShow}
                setLoginPopShow={setLoginShow}
                title={"로그인"} />
            <RegisterModal registerPopShow={registerShow}
                setRegisterPopShow={setRegisterShow}
                title={"회원가입"} />
        </actionContext.Provider>
    );
}

